<template>
    <div>
        <p>Specializing in web design and development,<br> UX/UI design, photography, video production, and more.</p>
        <a href="mailto:jeremy@jxl.io" target="_blank">CONTACT</a>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
    /* div {
        padding-bottom: 25px;
    } */
    a {
        color: #fff;
        font-weight: 900;
    }
    a:hover {
        color: #eee;
    }
</style>